module.exports = __webpack_public_path__ + "static/media/8229693_537_42ab.4ca0e394.jpg";